import { IOrderProduct } from '../../types/orderProduct';

export interface DirectSaleCartState {
  items: IOrderProduct[];
}

export const UPSERT_DIRECT_SALE_PRODUCT = 'UPSERT_DIRECT_SALE_PRODUCT';
export const REMOVE_DIRECT_SALE_PRODUCT = 'REMOVE_DIRECT_SALE_PRODUCT';
export const EMPTY_DIRECT_SALE_CART = 'EMPTY_DIRECT_SALE_CART';

export interface UpsertDirectSaleProductAction {
  type: typeof UPSERT_DIRECT_SALE_PRODUCT;
  payload: {
    productOrder: IOrderProduct;
  };
}

export interface RemoveDirectSaleProductAction {
  type: typeof REMOVE_DIRECT_SALE_PRODUCT;
  payload: {
    productOrderId: number;
  };
}

export interface EmptyDirectSaleCartAction {
  type: typeof EMPTY_DIRECT_SALE_CART;
}

export type DirectSaleCartActionTypes =
  | UpsertDirectSaleProductAction
  | RemoveDirectSaleProductAction
  | EmptyDirectSaleCartAction;
